import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '.';
import { CONTROLLERS, ENDPOINTS } from '../constants';
import { CreatePracticeScheduleJobCommand, Response, UpdatePracticeScheduleJobCommand } from '../models';
@Injectable({
  providedIn: 'root',
})
export class ScheduleJobService {
  private api: string = CONTROLLERS.SCHEDULE_JOB;
  constructor(private apiService: ApiService) {}

  createScheduleJob(
    practiceScheduleConfig: CreatePracticeScheduleJobCommand
  ): Observable<Response<any>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.SCHEDULE_JOB.CREATE_SCHEDULE_JOB}`,
      practiceScheduleConfig
    );
  }

  updateScheduleJob(
    practiceScheduleConfig: UpdatePracticeScheduleJobCommand
  ): Observable<Response<any>> {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.SCHEDULE_JOB.UPDATE_SCHEDULE_JOB}`,
      practiceScheduleConfig
    );
  }
}
